import { resolveColor } from 'ui/styles/utils/colors';
import styled, { ExecutionContext } from 'styled-components';

export interface StyledSidebarProps {
  $wide?: boolean;
}

export const SidebarHeader = styled.div<StyledSidebarProps>`
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  ${({ theme, $wide }: ExecutionContext & StyledSidebarProps) =>
    $wide ? `padding: ${theme.sidebar.padding}px;` : `padding: ${theme.sidebar.paddingSmall}px`};
`;

export const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

export const SidebarFooter = styled.div<StyledSidebarProps>`
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  position: sticky;
  bottom: 0;
  ${({ theme, $wide }: ExecutionContext & StyledSidebarProps) =>
    $wide ? `padding: ${theme.sidebar.padding}px;` : `padding: ${theme.sidebar.paddingSmall}px`};
  background-color: ${({ theme }) => resolveColor(theme, 'background')};
  margin-top: auto;
`;
